import { ECPDActionTypes, TCPDActions } from '../../actions/cpd';
import { ECpdDraftStatus, ECpdLabelModalView, ECpdPrelandingModalView, ICPDState } from '../../types/cpd/cpd';

const defaultState: ICPDState = {
  isCpdAvailable: false,
  modals: {
    labelModal: {
      isOpen: false,
      modalView: ECpdLabelModalView.None,
    },
    prelandingModal: {
      isOpen: false,
      modalView: ECpdPrelandingModalView.None,
    },
    cpdDraftStatus: ECpdDraftStatus.init,
  },
};

export const cpdReducer = (state: ICPDState = defaultState, action: TCPDActions): ICPDState => {
  switch (action.type) {
    case ECPDActionTypes.setAvailableCpd: {
      return {
        ...state,
        isCpdAvailable: action.payload,
      };
    }

    case ECPDActionTypes.setLabelModalOpen: {
      return {
        ...state,
        modals: {
          ...state.modals,
          labelModal: action.payload,
        },
      };
    }

    case ECPDActionTypes.setPrelandingModalOpen: {
      return {
        ...state,
        modals: {
          ...state.modals,
          prelandingModal: action.payload,
        },
      };
    }

    case ECPDActionTypes.setCpdDraftId: {
      return {
        ...state,
        modals: {
          ...state.modals,
          cpdDraftId: action.payload,
        },
      };
    }

    case ECPDActionTypes.setCpdDraftStatus: {
      return {
        ...state,
        modals: {
          ...state.modals,
          cpdDraftStatus: action.payload,
        },
      };
    }

    case ECPDActionTypes.setCpdSource: {
      return {
        ...state,
        modals: {
          ...state.modals,
          source: action.payload,
        },
      };
    }

    case ECPDActionTypes.setCpdCianSource: {
      return {
        ...state,
        modals: {
          ...state.modals,
          cianSource: action.payload,
        },
      };
    }

    case ECPDActionTypes.setCustomCpdDealType: {
      return {
        ...state,
        modals: {
          ...state.modals,
          customCpdDealType: action.payload,
        },
      };
    }

    default:
      return state;
  }
};
